export const imageExtensions = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
  "ico",
  "tiff",
  "tif",
  "avif",
]);

export const videoExtensions = new Set([
  "mp4",
  "mkv",
  "avi",
  "mov",
  "wmv",
  "flv",
  "webm",
  "m4v",
  "mpg",
  "mpeg",
]);

export const audioExtensions = new Set([
  "mp3",
  "wav",
  "flac",
  "aac",
  "ogg",
  "wma",
  "m4a",
  "opus",
]);

export const textExtensions = new Set([
  "txt",
  "log",
  "md",
  "json",
  "xml",
  "yaml",
  "yml",
  "html",
  "htm",
  "rtf",
]);

/**
 * Returns true if a file with the given name can be previewed via MimeBasedViewer
 * (i.e. it has an image, video, audio, or text extension).
 */
export const isPreviewableUnsupportedExtension = (
  fileName: string | null
): boolean => {
  if (!fileName) return false;
  const ext = fileName.split(".").at(-1)?.toLowerCase();
  if (!ext) return false;
  return (
    imageExtensions.has(ext) ||
    videoExtensions.has(ext) ||
    audioExtensions.has(ext) ||
    textExtensions.has(ext)
  );
};
